export default __webpack_public_path__ + "static/media/3036.b8ee71d5.jpg";